import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("etms_token", data.token);
    const me = await api.get("/auth/me").catch(() => ({ data: data.user }));
    setUser(me.data);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("etms_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, logout, isAdmin: user?.role === "admin", can: (...p) => p.some((x) => user?.perms?.includes(x)) }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
